import React, { useMemo } from 'react'

import { styles as defaultStyles } from 'common/builder/components/chart/FlowChart/components/Button/DefaultButton.styles'
import { styles as textStyles } from 'common/builder/components/chart/FlowChart/components/Button/TextButton.styles'
import { ButtonAppearance } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

export const useButtonStyle = (
  appearance: ButtonAppearance,
  isHover: boolean,
  externalStyle?: React.CSSProperties,
) => {
  return useMemo(() => {
    const styles = appearance === ButtonAppearance.TEXT ? textStyles : defaultStyles
    const baseStyle = isHover ? styles.hover : styles.default
    return { ...baseStyle, ...externalStyle }
  }, [appearance, isHover, externalStyle])
}
